/**************************************************
 * Nombre:       Home_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import tmp_anuncio from '../../../Recursos/Temporales/tmp_anuncio.png'
import {irUrl} from "../../../Utilidades/irUrl";

const Home_Anuncios = () => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Splide
                    aria-label="My Favorite Images"
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        arrows: true,
                        pagination: true,
                        width: '100%',
                        drag: false,
                        interval: 5000,
                        noDrag: true,
                        type: 'loop',


                    }}
                >

                    {items.map((item, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <img
                                    onClick={() => item.url ? irUrl(item.url) : ''}
                                    src={tmp_anuncio} style={{width: '100%', cursor: 'pointer'}}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>
            </Grid>

        </Grid>
    )

}
export default Home_Anuncios

const items = [1, 2, 3]